import validate from "/codebuild/output/src2959079407/src/lp/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45refresh_45token_45global from "/codebuild/output/src2959079407/src/lp/src/layers/sso/middleware/01.refresh-token.global.ts";
import _02_45authentication_45global from "/codebuild/output/src2959079407/src/lp/src/layers/sso/middleware/02.authentication.global.ts";
import manifest_45route_45rule from "/codebuild/output/src2959079407/src/lp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45refresh_45token_45global,
  _02_45authentication_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "unauthenticated-only": () => import("/codebuild/output/src2959079407/src/lp/src/layers/sso/middleware/unauthenticated-only.ts")
}